import React from "react";

const BS5_InputGroups = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_InputGroups Component</h2>
      <p>This is the BS5_InputGroups component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_InputGroups;
